import React from "react";
import { store } from 'react-notifications-component';
import { useGlobalContext } from '../../context/GlobalContext';
import { updateUserLunchPresenceAction } from '../../../actions/usersActions';

import contact  from "../../../assets/images/icons/contact.svg";
import flag  from "../../../assets/images/icons/flag.svg";

export default function LunchReceptionRow(props) {
  const { user , event } = props;
  const dispatch = useGlobalContext()[1];

  async function handleToggle() {
    const result = await updateUserLunchPresenceAction(dispatch , user._id, event );
    if (result && result.ok === false) {
      store.addNotification({
        message: result.error || 'Paiement du déjeuner requis pour ce jour.',
        type: "danger",
        insert: "top",
        container: "bottom-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true
        }
      });
    }
  }

  return (
    <div className="list-row">
      <div className="name">
          <div className="icon">
            <img src={contact} alt="user"/>
          </div>
          {user.profile.lastName} {user.profile.firstName}
        </div>
        <div className="info reception">

          <div className="company">
            {user && user.company && user.company[0] &&
              <p>{user.company[0].name}</p>
            }
          </div>

            {user && user?.lunchHere?.find(item => item === event) ?
              <div
                className="btn-is-here"
                onClick={handleToggle}>
                <div className="picto">
                  <img src={flag} alt="icon-flag"/>
                  <p style={{ width: 30 , marginLeft: 10 }}>oui</p>
                </div>
              </div>
              :
              <div
                className="btn-is-here"
                onClick={handleToggle}>
                <div className="picto not-active">
                  <img src={flag} alt="icon-flag"/>
                  <p style={{ width: 30 , marginLeft: 10 }}>non</p>
                </div>
              </div>
            }
        </div>
    </div>
  )
}
